import React, { useState, useEffect } from "react";
import ContentHeader from "../../../components/ContentHeader";
import Content from "../../../components/Content";
import CardHeader from "../../../components/CardHeader";
import MUIDataTable from "mui-datatables";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { ExportExcel } from "../../../components/ExportExcel/ExportExcel";
import Loading from "../../../components/Loading";
import api from "../../../services/api";
import './Relatorios.css'

import {
  ajustaActiveClassMenu,
} from "../../../util/rotinas";

import { formatTypeMoviment, formatInstituition, formatNumber, textLabels } from './utils'

import dayjs from 'dayjs'
import ptBr from 'dayjs/locale/pt-br'
import LocalizedFormat from 'dayjs/plugin/localizedFormat'
dayjs.locale(ptBr)
dayjs.extend(LocalizedFormat)

export default function Relatorios() {

  const [loading, setLoading] = useState(false);
  const [moviments, setMoviments] = useState([])
  const [movimentsFiltered, setMovimentsFiltered] = useState([])

  const [startDate, setStartDate] = useState(() => dayjs().subtract(15, 'day').startOf('day').toISOString())
  const [endDate, setEndDate] = useState(() => dayjs().startOf('day').toISOString())
  const [filterDateIni, setFilterDateIni] = useState(dayjs().subtract(15, 'day').format('YYYY-MM-DD'))
  const [filterDateFim, setFilterDateFim] = useState(dayjs().format('YYYY-MM-DD'))

  const [dataAtual, setDataAtual] = useState(undefined)

  useEffect(() => {
    ajustaActiveClassMenu("relMenu", "reportMenu");
  }, []);

  useEffect(() => {
    if (dataAtual === undefined) {
      let data = new Date();
      let dia = String(data.getDate()).padStart(2, '0');
      let mes = String(data.getMonth() + 1).padStart(2, '0');
      let ano = data.getFullYear();
      let dataAtual = ano + '-' + mes + '-' + dia;
      setDataAtual(dataAtual)
    }
  }, [dataAtual])

  async function getMoviments(start, end) {
    setLoading(true);
    try {
      await api.get(`/moviment/filtered?startDate=${start}&endDate=${end}`).then((res) => {
        let temp = res.data.data.map(movimentItem => {
          if (movimentItem.fee !== null && movimentItem.fee.percent !== 0) {
            if (Number(movimentItem.fee.value) > (Number(movimentItem.fee.percent) * (Number(movimentItem.value) / 100))) {
              return {
                ...movimentItem,
                instituition: formatInstituition(movimentItem.instituition_id),
                fee: movimentItem.fee !== null ? formatNumber(Number(movimentItem.fee.value)) : 0,
                customer: movimentItem.customer.fantasy_name,
                type: formatTypeMoviment(movimentItem.type)
              }
            }
            else {
              return {
                ...movimentItem,
                instituition: formatInstituition(movimentItem.instituition_id),
                fee: movimentItem.fee !== null ? formatNumber((Number(movimentItem.fee.percent) * (Number(movimentItem.value) / 100))) : 0,
                customer: movimentItem.customer.fantasy_name,
                type: formatTypeMoviment(movimentItem.type)
              }
            }
          }
          else {
            return {
              ...movimentItem,
              instituition: formatInstituition(movimentItem.instituition_id),
              fee: movimentItem.fee !== null ? formatNumber(Number(movimentItem.fee.value)) : 0,
              customer: movimentItem.customer.fantasy_name,
              type: formatTypeMoviment(movimentItem.type)
            }
          }
        })
        setMoviments(temp)
        setMovimentsFiltered(temp)
      })
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getMoviments(startDate, endDate)
  }, [])

  const columnsMoviments = [
    {
      name: "created_at",
      label: "Data",
      options: {
        filter: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: 'flex', justifyContent: "center", paddingLeft: "8px" }}>
              {dayjs(value).format('lll')}
            </div>
          )
        }
      }
    },
    {
      name: "customer",
      label: "Cliente",
      options: {
        filter: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: 'flex', justifyContent: "center", paddingLeft: "8px" }}>
              {value}
            </div>
          )
        },
        sort: true,
      }
    },
    {
      name: "instituition",
      label: "Instituição",
      options: {
        filter: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: 'flex', justifyContent: "center", paddingLeft: "auto" }}>
              {value}
            </div>
          )
        }
      }
    },
    {
      name: "type",
      label: "Tipo",
      options: {
        filter: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: 'flex', justifyContent: "center", paddingLeft: "8px" }}>
              {value}
            </div>
          )
        }
      }
    },
    {
      name: "nsu",
      label: "Nº Cupom",
      options: {
        filter: true,
        filterType: "textField",
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: 'flex', justifyContent: "center", paddingLeft: "8px" }}>
              {value}
            </div>
          )
        }
      }
    },

    {
      name: "value",
      label: "Valor da transação",
      options: {
        filter: true,
        filterType: "textField",
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: 'flex', justifyContent: "center", paddingLeft: "8px" }}>
              {formatNumber(Number(value))}
            </div>
          )
        }
      }
    },
    {
      name: "fee",
      label: "Taxa",
      options: {
        filter: true,
        filterType: "textField",
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: 'flex', justifyContent: "center", paddingLeft: "8px" }}>
              {value}
            </div>
          )
        }
      }
    },

  ];

  const options = {
    selectableRows: 'none',
    filter: true,
    filterType: 'dropdown',
    responsive: 'standard',
    search: true,
    viewColumns: true,
    download: false,
    print: true,
    textLabels: textLabels
  };

  const handleChangeFilterDate = function (e, errors, values) {
    getMoviments(filterDateIni, filterDateFim)
  }

  function clearFilterDate() {
    setMovimentsFiltered(moviments)
  }

  function calcularDataMaxima(dataFinal) {
    return dayjs(dataFinal).subtract(60, 'day').format('YYYY-MM-DD')
  }

  function calcularDataMinima(dataInicial) {
    const today = dayjs().toDate()
    const possibleDateMinima = dayjs(dataInicial).add(60, 'day').toDate()
    return possibleDateMinima > today ? dayjs(today).format('YYYY-MM-DD') : dayjs(possibleDateMinima).format('YYYY-MM-DD')
    // return dayjs(dataInicial).add(30, 'day').format('YYYY-MM-DD')
  }

  const handleDataInicialChange = (event) => {
    setFilterDateIni(event.target.value);
  };

  const handleDataFinalChange = (event) => {
    setFilterDateFim(event.target.value);
  };

  return (
    <>
      <ContentHeader
        urlPrevious="/"
        previousTitle=" Pagina Inicial"
        smallTitle="Relatórios"
      />
      <Content>
        <CardHeader
          title={"Relatórios"}
          icon={"fa fa-book"}
          searchVisible={false}

        />
        <AvForm onSubmit={handleChangeFilterDate}>
          <div style={{ display: 'flex', justifyContent: "space-around", padding: "10px 10px 0px 10px" }}>
            <div className="col-md-5">
              <div className="form-group">
                {dataAtual &&
                  <AvField
                    type="date"
                    name="filterDateIni"
                    label="Inicio"
                    value={filterDateIni}
                    min={filterDateFim ? calcularDataMaxima(filterDateFim) : ''}
                    max={dayjs().format('YYYY-MM-DD')}
                    required
                    onChange={handleDataInicialChange}
                    errorMessage="Forneça uma data válida"
                    validate={{
                      date: {
                        format: 'DD/MM/YYYY',
                        errorMessage: "Forneça uma data válida",
                      },
                      required: {
                        value: true,
                        errorMessage: "Forneça uma data válida",
                      },
                      min: {
                        value: filterDateFim ? calcularDataMaxima(filterDateFim) : '',
                        errorMessage: `Não é permitido um intervalo maior que 30 dias`,
                      },
                      max: {
                        value: dayjs().format('YYYY-MM-DD'),
                        errorMessage: `Não é permitido um intervalo maior que 30 dias`,
                      },
                    }}
                  />
                }
              </div>
            </div>
            <div className="col-md-5">
              <div className="form-group">
                {dataAtual &&
                  <AvField
                    type="date"
                    required
                    name="filterDateFim"
                    label="Fim"
                    value={filterDateFim}
                    max={filterDateIni ? calcularDataMinima(filterDateIni) : ''}
                    onChange={handleDataFinalChange}
                    errorMessage="Forneça uma data válida"
                    validate={{
                      required: {
                        value: true,
                        errorMessage: "Forneça uma data válida",
                      },
                      min: {
                        value: filterDateFim ? calcularDataMaxima(filterDateFim) : '',
                        errorMessage: `Não é permitido um intervalo maior que 30 dias`,
                      },
                      max: {
                        value: filterDateIni ? calcularDataMinima(filterDateIni) : '',
                        errorMessage: `Não é permitido um intervalo maior que 30 dias`,
                      },
                    }}
                  />
                }
              </div>
            </div>
            <div style={{ display: "flex", alignItems: 'center', marginTop: "12px" }}>
              <button className="button-export" type="submit" disabled={false} > Buscar</button>
            </div>
          </div>
        </AvForm>
        {loading ? (
          <div style={{ margin: '20px' }}>

            <Loading loading={loading} margin={"0px"} size={72} color={"black"} />
          </div>
        ) :
          <MUIDataTable
            title={"Movimentações"}
            data={movimentsFiltered}
            columns={columnsMoviments}
            options={options}
          />}
      </Content>
    </>
  )
}